import type { FiatCurrency } from '@0xtorch/core'
import { eur, idr, jpy, sgd, usd } from '@0xtorch/core'

export const fiatCurrencies: readonly FiatCurrency[] = [usd, jpy, eur, sgd, idr]
